import React, { useEffect } from 'react';
import { TableCell } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import moment from 'moment';

function Processos({
  etapas,
  status,
  encerramento,
  observacao,
  observacao_interna,
}) {
  const options = [
    {
      value: 'EM ANDAMENTO',
      label: 'Em Andamento',
    },
    {
      value: 'CONCLUIDO',
      label: 'Concluído',
    },
    {
      value: 'NAO INICIADO',
      label: 'Não Iniciado',
    },
  ];

  return (
    <>
      <TableCell align="center">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="body1" gutterBottom>
            {etapas}
          </Typography>
        </Grid>
      </TableCell>
      <TableCell align="center">
        <Typography>{status}</Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>
          {encerramento ? moment(encerramento).format('DD/MM/YYYY') : ''}
        </Typography>
      </TableCell>
      <TableCell align="center">
        <Typography>{observacao}</Typography>
      </TableCell>
    </>
  );
}

export default Processos;
